import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FilterSetModule } from '../../filter-set/filter-set.module'
import { SearchFiltersModule } from '../../search-filters/search-filters.module'
import { GridContainerModule } from '../grid-container/grid-container.module'
import { FilterableGridComponent } from './filterable-grid.component'

@NgModule({
  imports: [CommonModule, GridContainerModule, FilterSetModule, SearchFiltersModule],
  declarations: [FilterableGridComponent],
  exports: [FilterableGridComponent]
})
export class FilterableGridModule {}
